import { ReferencedEntry } from 'contentful';
import { useEffect, useState } from 'react';

import { SalesChannel } from 'src/api/contentful/contentTypes.shop';

import { PartnerInfo, fetchPartnerInfo } from './Util';
import { ValidationState } from './ValidationState';

export function useValidPartnerInfo(locale: string, trackingHost: string, initialValue = ValidationState.INIT, initialEntry?: ReferencedEntry<SalesChannel>) {
  const [ partnerInfo, setPartnerInfo ] = useState<PartnerInfo>({ state: initialValue, entry: initialEntry });

  useEffect(() => {
    const { state, entry } = partnerInfo;

    if (state !== ValidationState.INIT) return;

    setPartnerInfo({ state: ValidationState.PENDING, entry });

    fetchPartnerInfo(locale, trackingHost).then(
      response => {
        setPartnerInfo(response);
        if (response.redirectUrl) {
          location.assign(response.redirectUrl);
          return;
        }
      },
      () => setPartnerInfo({ state: ValidationState.INVALID, entry })
    );
  });

  return partnerInfo;
}
